module.exports = __webpack_public_path__ + "static/media/enisaWhite.c9c78c38.webp";